<lfw-offline-order-list [orders$]="offlineOrders$" [showTemporaryOrderList]="false" />
